<template>
  <div class="comp-paginator">
    <div class="container">
      <button type="button" @click="backward()" :class="{ disabled: ioffset === 1 }">
        <Icon name="chevronLeft" />
      </button>

      <template v-for="page in visiblePages">
        <button
          type="button"
          :class="{ disabled: ioffset === page }"
          :key="`button-${page}`"
          @click="go(page)">
            {{ page }}
        </button>
      </template>

      <button type="button" @click="forward()" :class="{ disabled: ioffset === numPages }">
        <Icon name="chevronRight" />
      </button>
    </div>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Paginator',
    components: {
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      offset: {
        type: Number,
        default: 1,
      },
      limit: {
        type: Number,
        default: 0,
      },
      total: {
        type: Number,
        default: 0,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        ioffset: this.offset,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      numPages() {
        const num = Math.floor(this.total / this.limit);
        return num === 0 ? 1 : num;
      },
      visiblePages() {
        const out = [];
        const numPages = this.numPages;
        const offset = this.ioffset;
        let start = offset - 2;
        start = start < 1 ? 1 : start;
        let end = start + 4;
        if (end > numPages) {
          start = numPages - 4;
          end = numPages;
        }

        if (numPages < 5) {
          start = 1;
          for (let i = 1; i <= end; i += 1) { out.push(i); }
          return out;
        }

        for (let i = start; i <= end; i += 1) { out.push(i); }
        return out;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      offset(value) {
        this.ioffset = value;
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      backward() {
        let offset = this.offset - 1;
        offset = (offset < 1) ? 1 : offset;
        this.$emit('update:offset', offset);
      },
      forward() {
        const numPages = this.numPages;
        let offset = this.offset + 1;
        offset = (offset > numPages) ? numPages : offset;
        this.$emit('update:offset', offset);
      },
      go(value) {
        this.$emit('update:offset', value);
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-paginator {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 22px 0;

  & > .container {
    display: inline-flex;
    gap: 8px;

    & > button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 39px;
      height: 32px;
      border: 0;
      background-color: $color-black-solid-05;
      border-radius: $default-border-radius;
      @include font-button;
      color: $color-black-alpha-60;
      user-select: none;
      cursor: pointer;

      &:first-of-type { margin-right: 4px; }
      &:last-of-type { margin-left: 4px; }
      & > svg {
        width: 14px;
        height: 14px;
      }

      &.disabled {
        background: $color-black-solid-05;
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }
}
</style>
